import styled from "@emotion/styled";
import { theme } from "@product/scmp-sdk";

export const Container = styled.div`
  inline-size: 100%;
  min-block-size: 384px;

  &:empty {
    padding-block-end: 76%;
  }
  ${theme.breakpoints.up("tablet")} {
    min-block-size: 554px;
    &:empty {
      padding-block-end: 0;
    }
  }
  ${theme.breakpoints.up("desktop")} {
    block-size: 545px;
    min-block-size: auto;
  }
  ${theme.breakpoints.up("largeDesktop")} {
    block-size: 594px;
  }
`;
